import { AxiosResponse } from "axios"
import StorageHelper from "./StorageHelper"

export default class AxiosPostProcessor {
    static postProcess<T extends AxiosResponse>(result: Promise<T>): Promise<T> {
        return result.then(t => {
            if(t.headers) {
                if(t.headers['clearlogintoken']) {
                    localStorage.removeItem('logintoken') // don't need to use StorageHelper to ask permission, as we're clearing it
                }
                else if(t.headers['setlogintoken']) {
                    StorageHelper.setItem('logintoken', t.headers['setlogintoken'])
                }
            }
            return t
        })
    }
}